<template>
  <div class="pm-wrapper">
    <button type="button" class="pm-image-button" @click="openForm">
      <img src="https://trackandraces.com/dominio/tr/pmactivo.png" alt="Pago Móvil Express" />
    </button>

    <v-dialog v-model="localDialog" max-width="620" persistent>
      <v-card class="reconcile-card">
        <div class="reconcile-hero">
          <div class="reconcile-hero-content">
            <v-icon dark>mdi-cellphone-check</v-icon>
            <div>
              <div class="reconcile-title">Conciliar Pago Móvil</div>
              <div class="reconcile-subtitle">Ingresa los datos exactos de la operación</div>
            </div>
          </div>

          <v-btn icon dark @click="closeForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="px-4 pt-4 pb-1">
          <v-alert
            v-if="formAlert.show"
            :type="formAlert.type"
            dense
            outlined
            class="mb-3"
            transition="fade-transition"
          >
            {{ formAlert.text }}
          </v-alert>

          <div class="payment-info-box">
            <div class="payment-info-header">
              <v-icon small color="#0f766e">mdi-bank-transfer</v-icon>
              <div class="payment-info-title">Datos para Pago Móvil</div>
            </div>

            <div class="payment-info-row">
              <span class="payment-label">RIF</span>
              <strong>J500728239</strong>

              <v-btn icon x-small color="primary" @click="copyToClipboard('500728239')">
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </div>

            <div class="payment-info-row">
              <span class="payment-label">Teléfono</span>
              <strong>04140898443</strong>

              <v-btn icon x-small color="primary" @click="copyToClipboard('04140898443')">
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </div>

            <div class="payment-info-row">
              <span class="payment-label">Banco</span>
              <strong>0171 - BANCO ACTIVO</strong>
              <span class="copy-placeholder"></span>
            </div>
          </div>

          <v-form
            ref="reconcileForm"
            v-model="reconcileValid"
            lazy-validation
            @keydown.enter.prevent="submitForm"
          >
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  v-model="form.bancoOrigen"
                  :items="bankItems"
                  item-text="text"
                  item-value="value"
                  label="Banco origen"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-bank"
                  :disabled="loadingSubmit || successMode"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.telefonoPagador"
                  label="Teléfono pagador"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required, rules.phoneVzla]"
                  hint="Ejemplo: 04XXXXXXXXX"
                  persistent-hint
                  maxlength="11"
                  prepend-inner-icon="mdi-phone"
                  :disabled="loadingSubmit || successMode"
                  @input="sanitizePhone"
                  @keypress="allowOnlyDigits"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.fechaPago"
                  label="Fecha de pago"
                  type="date"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-calendar-blank-outline"
                  :disabled="loadingSubmit || successMode"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.referencia"
                  label="Referencia"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required, rules.ref]"
                  hint="Últimos 6 dígitos"
                  persistent-hint
                  maxlength="20"
                  prepend-inner-icon="mdi-pound"
                  :disabled="loadingSubmit || successMode"
                  @keypress="allowOnlyAlphaNum"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.importe"
                  label="Monto del pago"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required, rules.amountPositive]"
                  hint="Ejemplo: 1500"
                  persistent-hint
                  prepend-inner-icon="mdi-cash"
                  :disabled="loadingSubmit || successMode"
                  @blur="normalizeAmount"
                  @keypress="allowOnlyAmount"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="soft-divider"></v-divider>

        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>

          <template v-if="successMode">
            <v-btn class="primary-cta" depressed dark @click="closeForm">
              Cerrar
            </v-btn>
          </template>

          <template v-else>
            <v-btn text class="cancel-ghost" :disabled="loadingSubmit" @click="closeForm">
              Cancelar
            </v-btn>

            <v-btn
              class="primary-cta"
              depressed
              dark
              :loading="loadingSubmit"
              :disabled="!reconcileValid || loadingSubmit"
              @click="submitForm"
            >
              <span v-if="!loadingSubmit">Enviar conciliación</span>
              <span v-else>Enviando…</span>
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PagoMovilConciliacionDialog",

  data() {
    return {
      endpoint: "https://apitr.xyz/onlineapi/api/dev/pasarela/pmactivo",

      localDialog: false,
      reconcileValid: false,
      loadingSubmit: false,
      successMode: false,

      formAlert: {
        show: false,
        type: "info",
        text: ""
      },

      form: {
        telefonoPagador: "",
        bancoOrigen: "",
        referencia: "",
        fechaPago: this.todayDate(),
        importe: ""
      },

      bankItems: [
        { text: "Banco de Venezuela", value: "0102" },
        { text: "Venezolano de Crédito", value: "0104" },
        { text: "Mercantil", value: "0105" },
        { text: "Provincial", value: "0108" },
        { text: "Bancaribe", value: "0114" },
        { text: "Banco Exterior", value: "0115" },
        { text: "BOD", value: "0116" },
        { text: "Banco Plaza", value: "0138" },
        { text: "Banesco", value: "0134" },
        { text: "Banco Fondo Común", value: "0151" },
        { text: "100% Banco", value: "0156" },
        { text: "Del Sur Banco", value: "0157" },
        { text: "Banco del Tesoro", value: "0163" },
        { text: "Banco Agrícola de Venezuela", value: "0166" },
        { text: "Bancrecer", value: "0168" },
        { text: "Mi Banco", value: "0169" },
        { text: "Banco Activo", value: "0171" },
        { text: "Bancamiga", value: "0172" },
        { text: "Banco Internacional de Desarrollo", value: "0173" },
        { text: "Banplus", value: "0174" },
        { text: "Bicentenario", value: "0175" },
        { text: "Novo Banco", value: "0176" },
        { text: "Banco Nacional de Crédito", value: "0191" }
      ],

      rules: {
        required: value => !!value || "Este campo es obligatorio",

        phoneVzla: value => {
          const phone = String(value || "").replace(/\D/g, "");
          return /^0\d{10}$/.test(phone) || "Debe tener 11 dígitos. Ej: 04140898443";
        },

        ref: value => {
          return /^[a-zA-Z0-9]{6,20}$/.test(value || "") || "Debe ser alfanumérica, entre 6 y 20 caracteres";
        },

        amountPositive: value => {
          if (!value) return "Este campo es obligatorio";

          const normalized = String(value).replace(",", ".");
          const validFormat = /^\d+(\.\d{1,2})?$/.test(normalized);

          if (!validFormat) return "Monto inválido. Ej: 1500 o 1500.00";

          return parseFloat(normalized) > 0 || "El monto debe ser mayor a cero";
        }
      }
    };
  },

  methods: {
    openForm() {
      this.localDialog = true;
    },

    todayDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    copyToClipboard(value) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value)
          .then(() => {
            this.showAlert("success", "Dato copiado al portapapeles.");
          })
          .catch(() => {
            this.showAlert("error", "No se pudo copiar el dato.");
          });

        return;
      }

      const input = document.createElement("input");
      input.value = value;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);

      this.showAlert("success", "Dato copiado al portapapeles.");
    },

    sanitizePhone() {
      this.form.telefonoPagador = String(this.form.telefonoPagador || "")
        .replace(/\D/g, "")
        .slice(0, 11);
    },

    phoneForPayload() {
      const phone = String(this.form.telefonoPagador || "").replace(/\D/g, "");

      if (phone.length === 11 && phone.charAt(0) === "0") {
        return phone.substring(1);
      }

      return phone;
    },

    allowOnlyDigits(event) {
      const char = String.fromCharCode(event.which);
      if (!/[0-9]/.test(char)) event.preventDefault();
    },

    allowOnlyAlphaNum(event) {
      const char = String.fromCharCode(event.which);
      if (!/[a-zA-Z0-9]/.test(char)) event.preventDefault();
    },

    allowOnlyAmount(event) {
      const char = String.fromCharCode(event.which);
      const currentValue = event.target.value || "";

      if (!/[0-9.,]/.test(char)) {
        event.preventDefault();
        return;
      }

      if ((char === "." || char === ",") && /[.,]/.test(currentValue)) {
        event.preventDefault();
      }
    },

    normalizeAmount() {
      if (!this.form.importe) return;

      const amount = parseFloat(String(this.form.importe).replace(",", "."));

      if (!isNaN(amount)) {
        this.form.importe = amount.toFixed(2);
      }
    },

    resetAlert() {
      this.formAlert = {
        show: false,
        type: "info",
        text: ""
      };
    },

    showAlert(type, text) {
      this.formAlert = {
        show: true,
        type,
        text
      };
    },

    resetForm() {
      this.form = {
        telefonoPagador: "",
        bancoOrigen: "",
        referencia: "",
        fechaPago: this.todayDate(),
        importe: ""
      };

      this.reconcileValid = false;
      this.loadingSubmit = false;
      this.successMode = false;
      this.resetAlert();

      this.$nextTick(() => {
        if (this.$refs.reconcileForm) {
          this.$refs.reconcileForm.resetValidation();
        }
      });
    },

    closeForm() {
      this.localDialog = false;
      this.resetForm();
    },

    buildPayload() {
      this.normalizeAmount();

      return {
        telefonoPagador: this.phoneForPayload(),
        referencia: this.form.referencia,
        fechaPago: this.form.fechaPago,
        importe: this.form.importe,
        bancoOrigen: this.form.bancoOrigen
      };
    },

    submitForm() {
      this.resetAlert();

      const isValid = this.$refs.reconcileForm.validate();

      if (!isValid) {
        this.showAlert("warning", "Por favor verifica los datos del formulario.");
        return;
      }

      this.loadingSubmit = true;

      const payload = this.buildPayload();

      axios.post(this.endpoint, payload, {
        timeout: 15000,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then((response) => {
          const result = response?.data || {};

          if (result.ok === true) {
            this.successMode = true;
            this.showAlert("success", result.message || "Conciliación exitosa.");
            this.$emit("success", result);
            return;
          }

          this.showAlert("error", result.message || "No se pudo conciliar el pago móvil.");
          this.$emit("failed", result);
        })
        .catch((error) => {
          const result = error?.response?.data || null;

          if (result) {
            this.showAlert("error", result.message || "No se pudo conciliar el pago móvil.");
            this.$emit("failed", result);
            return;
          }

          if (error?.code === "ECONNABORTED") {
            this.showAlert("error", "La solicitud tardó demasiado. Intenta nuevamente.");
            return;
          }

          this.showAlert("error", error?.message || "Error de conexión.");
          this.$emit("error", error);
        })
        .finally(() => {
          this.loadingSubmit = false;
        });
    }
  }
};
</script>

<style scoped>
.pm-wrapper {
  width: 100%;
}

.pm-image-button {
  width: 60%;
  max-width: 280px;
  min-width: 80px;
  display: block;
  margin: 0 auto 0;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  border-radius: 5px;
  overflow: hidden;
  transition: transform .25s ease, box-shadow .25s ease;
}

.pm-image-button img {
  width: 100%;
  display: block;
  border-radius: 5px;
}

.pm-image-button:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, .18);
}

.pm-image-button:active {
  transform: scale(.98);
}

.reconcile-card {
  border-radius: 18px;
  overflow: hidden;
}

.reconcile-hero {
  min-height: 78px;
  padding: 16px 18px;
  background: linear-gradient(135deg, #0f766e, #0ea5e9);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.reconcile-hero-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.reconcile-hero-content .v-icon {
  font-size: 32px;
}

.reconcile-title {
  font-size: 19px;
  font-weight: 700;
  line-height: 1.2;
}

.reconcile-subtitle {
  font-size: 13px;
  opacity: 0.9;
  margin-top: 3px;
}

.payment-info-box {
  background: #f8fafc;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 14px;
}

.payment-info-header {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 8px;
}

.payment-info-title {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.payment-info-row {
  display: grid;
  grid-template-columns: 72px 1fr 32px;
  align-items: center;
  gap: 6px;
  padding: 6px 0;
  border-top: 1px solid #e2e8f0;
}

.payment-label {
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
  color: #64748b;
}

.payment-info-row strong {
  font-size: 13px;
  color: #0f172a;
  line-height: 1.2;
}

.copy-placeholder {
  width: 32px;
  height: 1px;
}

.soft-divider {
  opacity: 0.55;
}

.primary-cta {
  background: linear-gradient(135deg, #0f766e, #0ea5e9) !important;
  border-radius: 10px;
  text-transform: none;
  font-weight: 700;
  padding: 0 18px;
}

.cancel-ghost {
  text-transform: none;
  font-weight: 600;
}

@media (min-width: 600px) {
  .payment-info-box {
    padding: 12px 14px;
  }

  .payment-info-row strong {
    font-size: 14px;
  }
}

@media (max-width: 600px) {
  .pm-image-button {
    width: 90%;
    min-width: unset;
  }

  .reconcile-title {
    font-size: 17px;
  }

  .reconcile-subtitle {
    font-size: 12px;
  }
}
</style>